import { IconButton } from '@/components/IconButton'
import cx from 'classnames'
import { NumericSpinnerInput } from '@/components/inputs/NumericSpinnerInput'
import styles from './ScopeChangeInventoryItem.module.css'
import { Checkbox } from '@/components/Checkbox'

export interface ScopeChangeInventoryItemUpdateQuantityProps {
  name: string
  description: string
  currentQuantity: number
  newQuantity: number
  hasQuantityError: boolean
  onRemove: () => unknown
  onQuantityChange: (value: number | null) => unknown
  removeButtonTestId?: string
  quantityInputTestId?: string
}

export function ScopeChangeInventoryItemUpdateQuantity({
  name,
  description,
  currentQuantity,
  newQuantity,
  hasQuantityError,
  onRemove,
  onQuantityChange,
  removeButtonTestId,
  quantityInputTestId,
}: ScopeChangeInventoryItemUpdateQuantityProps) {
  return (
    <div className={styles.itemContainer}>
      <IconButton
        name="close"
        label="Remove item"
        className={styles.removeItemButton}
        onPress={onRemove}
        testId={removeButtonTestId}
        size={24}
      />

      <div className={styles.textContainer}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{description}</div>
      </div>

      <div className={styles.currentQuantityContainer}>{currentQuantity}</div>

      <NumericSpinnerInput
        min={0}
        value={newQuantity}
        onChange={onQuantityChange}
        invalid={hasQuantityError}
        testId={quantityInputTestId}
      />
    </div>
  )
}

export interface ScopeChangeInventoryItemSelectionProps {
  name: string
  description: string
  selected: boolean
  onToggle: () => unknown
  testId?: string
}

export function ScopeChangeInventoryItemSelection({
  name,
  description,
  selected,
  onToggle,
  testId,
}: ScopeChangeInventoryItemSelectionProps) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- Checkbox renders a native input nested inside this label
    <label
      className={cx(styles.itemContainer, selected && styles.selected)}
      data-test={testId}
    >
      <div className={styles.checkboxContainer}>
        <Checkbox checked={selected} onChange={onToggle} />
      </div>

      <div className={styles.textContainer}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </label>
  )
}
